import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { FilterBenefitGroup } from "../models/filters/filter-benefit-group";
import { BenefitGroup } from "../models/benefit-group";

@Injectable({
  providedIn: 'root'
})
export class BenefitGroupService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/benefitsGroup'; 

  findAllPageableBenefitGroup(filterBenefitGroup: FilterBenefitGroup, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterBenefitGroup);
  }

  findBenefitGroupById(id: number): Observable<BenefitGroup> {
    return this.http.get<BenefitGroup>(`${this.url}/${id}`);
  }

  createBenefitGroup(benefitGroup: BenefitGroup): Observable<BenefitGroup>{
    return this.http.post<BenefitGroup>(this.url, benefitGroup);
  }

  updateBenefitGroup(benefitGroup: BenefitGroup): Observable<BenefitGroup>{
    return this.http.put<BenefitGroup>(`${this.url}/${benefitGroup.id}`, benefitGroup);
  }

}